import React, { useState } from 'react';
import { useAuth } from '../../providers/auth-provider/auth-provider';
import { canManuallyDelete } from '../../api/v3/manual-delete-api-v3';

export const MANUAL_DELETE_NOTE = 'Hanya customer atau produk yang tidak terkait dengan order yang belum dibatalkan yang dapat dihapus. Data yang terkait dengan order selesai tidak dapat dihapus.';

export default function ManualDeleteButton({ kind, label, onDelete, onDeleted }) {
  const { user } = useAuth();
  const [deleting, setDeleting] = useState(false);
  if (!user || !canManuallyDelete(user.role)) return null;

  async function handleDelete() {
    if (deleting || !window.confirm(`Hapus ${kind} ${label}?\n\n${MANUAL_DELETE_NOTE}`)) return;
    setDeleting(true);
    try {
      await onDelete();
      window.alert(`${kind} berhasil dihapus.`);
    } catch (e) {
      window.alert(e.message || 'Gagal menghapus data. Silakan coba lagi.');
      setDeleting(false);
      return;
    }
    setDeleting(false);
    if (onDeleted) await onDeleted();
  }

  return (
    <button type="button" className="btn btn-sm btn-danger text-white" style={{ marginLeft: 12 }} disabled={deleting} onClick={handleDelete}>
      {deleting ? 'Menghapus…' : 'Delete'}
    </button>
  );
}
